import { render, staticRenderFns } from "./ModalCurrentHistory.vue?vue&type=template&id=2d170e49&scoped=true"
import script from "./ModalCurrentHistory.vue?vue&type=script&lang=js"
export * from "./ModalCurrentHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalCurrentHistory.vue?vue&type=style&index=0&id=2d170e49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d170e49",
  null
  
)

export default component.exports